module.exports = __webpack_public_path__ + "img/loly2.9ad8d89d.jpg";